function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionUpIconWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 1163",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 551",
    width: 15,
    height: 12,
    rx: 3,
    style: {
      fill: "#ffa539"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Back Button"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.282 3.587L6.565 0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fillRule: "evenodd"
    },
    transform: "rotate(180 5.47 3.897)",
    "data-name": "icons/d/Down-arrow-16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionUpIconWithBg);
export default __webpack_public_path__ + "static/media/AccordionUpIconWithBG.4e9d2ce0786ef6d5a7a8fccbfd4cbd1e.svg";
export { ForwardRef as ReactComponent };